// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const SocialFacebookIcon = props => <Icon {...props} dangerouslySetIcon={'<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.549 21l-.026-8.182H6.25V9.545h3.273V7.5c0-3.037 1.88-4.5 4.589-4.5 1.298 0 2.413.097 2.738.14v3.173l-1.879.001c-1.473 0-1.758.7-1.758 1.727v1.504H17.5l-1.636 3.273h-2.651V21H9.549z" fill="currentColor"/></svg>'} />;

SocialFacebookIcon.displayName = 'SocialFacebookIcon';

export default SocialFacebookIcon;
